import { call, put } from 'redux-saga/effects'
import MasterCacheActions from '../Redux/MasterCacheRedux'
import LoginActions from '../Redux/LoginRedux'
export function * masterCache (api, {params}) {
  try {
    const res = yield call(api, params)
    if (res && res.message === 'Unauthenticated.') {
      yield put(LoginActions.loginFailure())
      return
    }
    if (res.success) {
      yield put(MasterCacheActions.masterCacheSuccess(res.data))
    } else {
      yield put(MasterCacheActions.masterCacheFailure(res.message))
    }
  } catch (error) {
    yield put(MasterCacheActions.masterCacheFailure(error.message))
  }
}
